if (!customElements.get("delivery-text")) {
  class DeliveryText extends HTMLElement {
    constructor() {
      super();
      this.init = this.init.bind(this);
    }

    swapToFallbackText() {
      this.classList.add("is-fallback");
    }

    replaceTextHoursAndMinutes(hour, minute) {
      const target = this.querySelector("[data-text]");
      if (!target) return;

      const template = target.getAttribute("data-text");

      const targetHour = 14;
      const totalNowMinutes = hour * 60 + minute;
      const totalTargetMinutes = targetHour * 60;

      const diffMinutes = Math.max(totalTargetMinutes - totalNowMinutes, 0);
      const hoursLeft = Math.floor(diffMinutes / 60);
      const minutesLeft = diffMinutes % 60;

      const updatedText = template
        .replace("[hour]", hoursLeft.toString())
        .replace("[minutes]", minutesLeft.toString());

      target.innerHTML = updatedText;
    }

    init() {
      const now = new Date();
      const options = {
        timeZone: "Europe/Amsterdam",
        hour12: false,
        hour: "numeric",
        minute: "numeric",
      };
      const formatter = new Intl.DateTimeFormat("en-GB", options);
      const parts = formatter.formatToParts(now);

      const hour = parseInt(parts.find((p) => p.type === "hour").value, 10);
      const minute = parseInt(parts.find((p) => p.type === "minute").value, 10);

      if (hour > 14 || (hour === 14 && minute >= 0)) {
        this.swapToFallbackText();
        clearInterval(this.interval);
        this.interval = null;

        return;
      }

      this.replaceTextHoursAndMinutes(hour, minute);

      if (!this.interval) {
        this.interval = setInterval(this.init, 10000);

        return;
      }
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define("delivery-text", DeliveryText);
}
